import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl-next';
import {
	addEventListener,
	removeEventListener,
} from '@confluence-classic/confluence-utils/src/tech-debt/facades/window.js';
import { getNavigator } from '@confluence-classic/confluence-utils/src/tech-debt/facades/navigator.js';

import Flag from '../../Flag/index.js';

class ErrorHandlerComponent extends Component {
	constructor(props) {
		super(props);
		this.handleConnectionIssues = this.handleConnectionIssues.bind(this);
		addEventListener('online', this.handleConnectionIssues);
		addEventListener('offline', this.handleConnectionIssues);
	}

	componentWillUnmount() {
		removeEventListener('online', this.handleConnectionIssues);
		removeEventListener('offline', this.handleConnectionIssues);
	}

	handleConnectionIssues() {
		const type = getNavigator().onLine ? 'success' : 'error';
		if (type === 'success') {
			this.props.connectionOnline();
		} else {
			this.props.connectionOffline();
		}
	}

	render() {
		const { error, intl, ...otherProps } = this.props;
		const { title, body, bodyKey, close } = error;

		let i18nTitle, flagBody;
		if (error.error) {
			const titleMessage = {
				id: title,
				// TODO: replace straight quotes with curly quotes (see go/curlyquotes)
				// eslint-disable-next-line no-restricted-syntax
				defaultMessage: "Something's gone wrong.",
			};
			i18nTitle = intl.formatMessage(titleMessage);

			const bodyKeyMessage = {
				id: bodyKey,
				defaultMessage: 'Try again later.',
			};
			const i18nBodyKey = intl.formatMessage(bodyKeyMessage);

			flagBody = body ? body.replace('i18nPlaceholder', i18nBodyKey) : i18nBodyKey;
		}

		return (
			<Flag
				isShowing={error.error}
				type={error.type}
				title={i18nTitle}
				body={flagBody}
				close={close}
				{...otherProps}
			/>
		);
	}
}

ErrorHandlerComponent.propTypes = {
	/**
	 * The error object from state
	 */
	error: PropTypes.object,
	/**
	 * The intl object containing the i18n strings
	 */
	intl: PropTypes.object,
	/**
	 * Dispatch function to hide errors
	 */
	onClose: PropTypes.func,
	/**
	 * Dispatch function to trigger a connection online action
	 */
	connectionOnline: PropTypes.func,
	/**
	 * Dispatch function to trigger a connection offline action
	 */
	connectionOffline: PropTypes.func,
};

export default injectIntl(ErrorHandlerComponent);
